import { render, staticRenderFns } from "./BaseInfoPopup.vue?vue&type=template&id=0c125dd4"
import script from "./BaseInfoPopup.vue?vue&type=script&lang=js"
export * from "./BaseInfoPopup.vue?vue&type=script&lang=js"
import style0 from "./BaseInfoPopup.vue?vue&type=style&index=0&id=0c125dd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports